'use client';

import React from 'react';

const GOLD_ACCENT = '#faaf40';
const SHADOW_GOLD = 'rgba(250, 175, 64, 0.6)';

export default function TrainerCard({ trainer }) {
  return (
    <div
      className="rounded-2xl bg-[#1c1c1c] overflow-hidden group w-[280px] min-h-[480px] max-h-[480px] flex flex-col"
      style={{
        border: `2px solid ${GOLD_ACCENT}`,
        boxShadow: `0 10px 25px ${SHADOW_GOLD}`,
      }}
    >
      {/* Fixed Image Section */}
      <div className="relative h-56 flex-shrink-0">
        <img
          src={trainer.imageUrl}
          alt={trainer.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
      </div>

      {/* Scrollable Text Section */}
      <div className="p-6 overflow-auto flex-1">
        <h3 className="text-2xl font-bold" style={{ color: GOLD_ACCENT }}>
          {trainer.name}
        </h3>
        <p className="text-sm uppercase tracking-wider text-gray-400 mb-4">
          {trainer.title}
        </p>
        <p className="text-gray-300 leading-relaxed">
          {trainer.bio}
        </p>
      </div>
    </div>
  );
}